var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#fee6e7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.041 36.401c-2.63-.89-4.4-5.608-4.4-7.495 0 0 1.921 2.845 6.229.792l4.185.562 7.333-1.354c0 1.887-1.775 6.605-4.4 7.495h-8.947z",
    fill: "#860006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.959 36.395c6.488 3.769 11.245 14.901 11.245 21.57-.02 8.125-7.04 13.156-15.703 13.156S34.816 66.09 34.816 57.964c0-6.668 4.737-17.8 11.244-21.57",
    fill: "#dd000a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.864 55.997v-1.3h1.144v-.858h-1.144v-1.3h1.144V49.64h2.041l1.651 2.899h2.08V49.64h1.82v2.899h1.04v1.3H54.6v.858h1.04v1.3H54.6V59h-1.95l-1.729-3.003h-2.093V59h-1.82v-3.003h-1.144zm2.964-1.3h1.339l-.494-.858h-.845v.858zm3.107 0h.845v-.858h-1.326l.481.858zm-3.107-2.158h.104l-.104-.182v.182zm3.952 3.64v-.182h-.104l.104.182z",
    fill: "#fbb0b3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f3000b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.499 71.999c-9.597 0-16.564-5.901-16.564-14.031 0-6.737 4.469-17.111 10.428-21.511-2.356-1.873-3.608-5.921-3.608-7.549a.88.88 0 0 1 .554-.82.88.88 0 0 1 .966.214c.029.029 2.826 2.933 6.165 2.933a.88.88 0 0 1 .622.258.88.88 0 0 1 .258.622.88.88 0 0 1-.258.622.88.88 0 0 1-.622.258c-1.95-.062-3.839-.696-5.432-1.823.64 1.809 1.843 3.911 3.31 4.4a.88.88 0 0 1 .593.745.88.88 0 0 1-.432.849c-5.974 3.466-10.785 14.217-10.785 20.802 0 7.226 6.087 12.271 14.804 12.271s14.804-5.045 14.804-12.271c0-6.585-4.811-17.336-10.785-20.807a.88.88 0 0 1-.432-.849.88.88 0 0 1 .593-.745c2.176-.724 3.804-5.06 3.804-6.664a.88.88 0 0 1 .88-.88.88.88 0 0 1 .88.88c0 1.628-1.257 5.676-3.608 7.549 5.959 4.424 10.428 14.779 10.428 21.511 0 8.135-6.967 14.036-16.564 14.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 33.758a.88.88 0 0 1-.841-.626c-.367-1.222-1.041-2.738-2.151-2.997-1.247-.288-2.811 1.036-3.261 1.52a.89.89 0 0 1-.281.202c-.106.048-.221.075-.337.079s-.233-.015-.342-.056-.209-.103-.294-.183a.89.89 0 0 1-.202-.281c-.048-.106-.075-.221-.079-.337s.015-.233.056-.342a.89.89 0 0 1 .183-.294c.098-.108 2.444-2.625 4.952-2.039 1.55.357 2.708 1.775 3.422 4.204a.88.88 0 0 1-.069.67c-.055.102-.129.191-.219.264a.88.88 0 0 1-.304.161.9.9 0 0 1-.235.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.484 31.912a.85.85 0 0 1-.313-.059.86.86 0 0 1-.513-1.09c.108-.318 1.252-3.051 7.744-2.738a.88.88 0 0 1 .836.919.89.89 0 0 1-.939.841c-5.143-.254-6.008 1.584-6.013 1.604a.91.91 0 0 1-.802.523zm3.525 5.426h-9.602a.88.88 0 1 1 0-1.76h9.602a.88.88 0 1 1 0 1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.576 41.046a.88.88 0 0 1-.861-.694c-.582-2.664-5.588-2.342-5.637-2.337a.88.88 0 0 1-.948-.807.88.88 0 0 1 .807-.948c.264 0 6.58-.489 7.499 3.715a.88.88 0 0 1-.67 1.046.9.9 0 0 1-.191.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.802 37.508c-.756-.007-1.503-.174-2.19-.489a.88.88 0 0 1-.358-1.159.88.88 0 0 1 1.14-.415c.682.317 1.456.379 2.181.176a2.41 2.41 0 0 0 1.325-1.467c.045-.107.111-.203.194-.284s.18-.145.288-.189.222-.065.338-.064.23.025.337.07.203.111.284.194.145.18.189.288.065.222.064.338-.025.23-.07.337a4.11 4.11 0 0 1-2.347 2.444c-.441.154-.907.228-1.374.22z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(28.5 28)",
    d: "M0 0h44v44H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoans);
export default __webpack_public_path__ + "static/media/loans.d4aa78bf7713f765837af4b9516dc773.svg";
export { ForwardRef as ReactComponent };